import { render, staticRenderFns } from "./UserSubscriptionDetail.vue?vue&type=template&id=0aa38258&"
import script from "./UserSubscriptionDetail.vue?vue&type=script&lang=js&"
export * from "./UserSubscriptionDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports